<template>
  <v-main id="landing" class="pt-0">
    <section id="intro" class="primary">
      <v-theme-provider dark>
        <Intro />
      </v-theme-provider>
    </section>
    <section id="idea">
      <v-theme-provider light>
        <Idea />
      </v-theme-provider>
    </section>
    <section id="command" class="grey lighten-3">
      <v-theme-provider light>
        <Command />
      </v-theme-provider>
    </section>
    <section id="strategy">
      <v-theme-provider light>
        <Strategy />
      </v-theme-provider>
    </section>
    <section id="copy" class="grey lighten-3">
      <v-theme-provider light>
        <Copy />
      </v-theme-provider>
    </section>
    <section id="price">
      <v-theme-provider light>
        <Price />
      </v-theme-provider>
    </section>
    <section id="footer">
      <v-theme-provider light>
        <Footer />
      </v-theme-provider>
    </section>
  </v-main>
</template>

<script>
import Intro from "@/components/homes/Intro.vue";
import Idea from "@/components/homes/Idea.vue";
import Command from "@/components/homes/Command.vue";
import Strategy from "@/components/homes/Strategy.vue";
import Copy from "@/components/homes/Copy.vue";
import Price from "@/components/homes/Prices.vue";
import Footer from "@/components/homes/Footer.vue";

export default {
  name: "Home",
  components: {
    Intro,
    Idea,
    Command,
    Strategy,
    Copy,
    Price,
    Footer
  },

  data() {
    return {};
  },
  methods: {}
};
</script>

<style>
/* #alert {
  height: 90vh;
}
#command {
  height: 90vh;
}
#strategy {
  height: 90vh;
}
#copy {
  height: 90vh;
} */
</style>